import type { PsHttpSSE } from '@/services/sse-ps-http/sse-ps-http';
import type { SpecificationStreamContent } from '../types/specification';

export interface SpecificationAiOptimizeParagraphRequest {
    /** 任务ID */
    task_id: string;
    /** 内容类型 */
    content_type: string;
    /** 优化类型 */
    optimize_type: string;
    /** 优化的内容 */
    text?: string;
}

export type SpecificationAiOptimizeParagraphResponse = string;

export const SpecificationAiOptimizeParagraphApi = Symbol.for('SpecificationAiOptimizeParagraphApi');

export interface SpecificationAiOptimizeParagraphApi {
    /**
     * 优化说明书正文段落
     * 不会自动保存到任务中
     */
    aiOptimizeSpecificationParagraph(data: SpecificationAiOptimizeParagraphRequest): PsHttpSSE<SpecificationStreamContent<SpecificationAiOptimizeParagraphResponse>>;
}
